import styled from "styled-components";
import { Card } from "react-bootstrap";

export const Container = styled.div`
  margin-bottom: 20px;
  margin-right: 36px;
  cursor: pointer;

  @media (max-width: 768px) {
    width: 100%;
    margin-right: 0px;
  }
`;

export const DivisionThumbnail = styled.div`
  width: 100%;
  height: auto;
`;

export const Thumbnail = styled.img`
  width: 100%;
  height: auto;

  @media (min-width: 768px) {
    width: 220px;
    height: 130px;
  }
`;
export const Module = styled.div`
  font-weight: 100;
  margin-top: 23px;
  color: #808080;
  font-size: 11px;
  @media (max-width: 768px) {
    margin-top: 0px;
  }
`;
export const Title = styled.div`
  color: #808080;
  font-weight: bold;
  font-size: 1.2rem;
  margin-bottom: 15px;

  @media (max-width: 768px) {
    margin-top: 2px;
    margin-bottom: 8px;
    font-size: 1rem;
  }
`;
export const Time = styled.div`
  font-weight: 100;
  font-size: 15px;
  color: #808080;
`;

export const Desktop = styled.div`
  @media (max-width: 768px) {
    display: none;
  }
`;

export const Mobile = styled.div`
  display: grid;
  grid-template-columns: 40% 60%;

  @media (min-width: 768px) {
    display: none;
  }
`;

export const Right = styled.div`
  margin-left: 20px;
`;

export const GridTraining = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 50%);
  width: 110%;
  margin-left: -5%;
`;

export const OutlineHomeButton = styled.button`
  width: 90%;
  padding: 0.5rem 0.5rem;
  margin: 0.5rem;
  border-radius: 0.4rem;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  border: 1.5px solid #000FFF;
  background-color: transparent;
  color: #000FFF;

  @media (max-width: 1280px) {
    padding: 0.4rem 0.4rem;
    font-size: 0.85rem;
  }

  @media (max-width: 1200px) {
    margin: 0.4rem;
  }
`;
